/* eslint-disable */
export const MODULE_NAME = 'favorites';
